import React from "react";
import { Star } from "lucide-react";
import { SectionHeading } from "./ui";
import { Reveal } from "./useReveal";

const REVIEWS = [
  {
    quote: "Wallstreet Realty made our first home purchase feel effortless. John and his team walked us through every step, from pre-approval to closing. We found our dream home in Cerritos within 3 weeks.",
    name: "Maria & Carlos G.", loc: "Cerritos, CA", tag: "Buyer", initials: "MC",
  },
  {
    quote: "Sold our family home for $85K over asking price. The marketing strategy was incredible, with professional photos, staging advice, and the right pricing from day one. Couldn't be happier.",
    name: "David L.", loc: "Lakewood, CA", tag: "Seller", initials: "DL",
  },
  {
    quote: "As investors, we needed an agent who understood the numbers. Wallstreet Realty helped us acquire two investment properties that are now cash-flowing beautifully. True professionals.",
    name: "Sarah & James T.", loc: "Long Beach, CA", tag: "Investor", initials: "SJ",
  },
];

const Stars = () => (
  <div className="flex gap-0.5 text-[#C9A961]">
    {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" />)}
  </div>
);

export const Testimonials = () => (
  <section className="py-16 lg:py-24 bg-[#2D2D37]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionHeading eyebrow="Client Stories" title="What Our Clients Say" light center />
      </Reveal>
      <div className="mt-12 grid grid-cols-1 lg:grid-cols-3 gap-6">
        {REVIEWS.map((r, i) => (
          <Reveal key={i} delay={i * 90}>
            <div
              data-testid={`testimonial-${i}`}
              className="lift h-full bg-white/[0.04] border border-white/10 rounded-[20px] p-8 flex flex-col"
            >
              <Stars />
              <p className="mt-4 text-white/85 leading-relaxed flex-1">“{r.quote}”</p>
              <div className="mt-6 flex items-center gap-3">
                <div className="w-11 h-11 rounded-full bg-[#254369] flex items-center justify-center font-heading font-bold text-white text-sm">
                  {r.initials}
                </div>
                <div>
                  <p className="font-heading font-bold text-white text-[15px]">{r.name}</p>
                  <p className="text-white/50 text-xs">{r.loc} · {r.tag}</p>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={120}>
        <div className="mt-10 flex flex-col items-center gap-2" data-testid="google-rating-badge">
          <Stars />
          <p className="font-heading font-bold text-white text-lg">5.0 Rating on Google</p>
          <p className="text-white/50 text-sm">Trusted by Southern California families</p>
        </div>
      </Reveal>
    </div>
  </section>
);
